import ConfirmModalHook from '@/components/common/ConfirmModal/ConfirmModal.hook'
import message from '@/libs/message'
import healthClaimFormAtom from '@/recoil/healthClaimForm/atom'
import { useSendToPv } from '@/services/healthClaim/useSendToPv'
import { useUpdateClaimStatus } from '@/services/healthClaim/useUpdateClaimStatus'
import { useRecoilValue } from 'recoil'
import { ClaimStatusCodeEnum } from '../../HealthClaimPage/ClaimHandlingTable/types'
import { useQueryClient } from '@tanstack/react-query'
import { showClaimErrorNotification } from '@/libs/utils/claim-error-notification.util'

export const SendPvButtonHook = () => {
  const { setConfirmModal } = ConfirmModalHook()
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const {
    mutateAsync: sendToPv,
    isSuccess: isSendToPvSuccess,
    isPending: isSendToPvPending,
  } = useSendToPv()

  const queryClient = useQueryClient()

  const {
    mutateAsync: updateClaimStatus,
    isSuccess: isUpdateStatusSuccess,
    isPending: isUpdateStatusPending,
  } = useUpdateClaimStatus()
  const isResendPv = !!healthClaim.data?.savePvAction
  const isApprovedStatus = healthClaim.data?.statusCode === ClaimStatusCodeEnum.APPROVED
  const handleApproveButtonClick = async () => {
    if (!healthClaim.data?.claimFormId) return

    try {
      if (isResendPv) {
        await sendToPv(healthClaim.data.claimFormId).then(() => {
          // Ensure detail is fresh when navigating
          queryClient.refetchQueries({
            queryKey: ['useGetClaimDetail', healthClaim.data?.claimFormId],
          })
        })
      } else if (isApprovedStatus) {
        await updateClaimStatus({
          claimFormId: healthClaim.data.claimFormId,
          claimStatus: ClaimStatusCodeEnum.PENDING_PAYMENT,
        }).then(() => {
          // Ensure detail is fresh when navigating
          queryClient.refetchQueries({
            queryKey: ['useGetClaimDetail', healthClaim.data?.claimFormId],
          })
        })
      }

      message.success({ content: 'ส่งข้อมูลสำเร็จ', duration: 10 })
    } catch (error: any) {
      showClaimErrorNotification(error)
    } finally {
      setConfirmModal({
        isVisible: false,
        onOkFunction: Function,
      })
    }
  }

  const handleClickSendPv = () => {
    setConfirmModal({
      isVisible: true,
      title: 'ยืนยันการส่ง PV',
      bodyText: 'คุณได้ตรวจสอบข้อมูลเรียบร้อยแล้วหรือไม่',
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      dataTestId: 'send-pv-modal',
      onOkFunction: async () => {
        await handleApproveButtonClick()
      },
    })
  }

  return {
    handleClickSendPv,
    isResendPv,
    isLoading: isSendToPvPending || isUpdateStatusPending,
    isSuccess: isSendToPvSuccess || isUpdateStatusSuccess,
    isEnableSendPvButton: isResendPv || isApprovedStatus,
  }
}
